import AddHolidaysPage from "../../../../component/holidays/add-holidays/AddHolidays";

function AddHolidays() {
  return (
    <div className="page-body">
      <AddHolidaysPage />
    </div>
  );
}

export default AddHolidays;
